import axios from 'axios';
import { getHeaders } from "./authService";
import { securePostAPI } from "./apiService";
// const baseMeetUrlSatging = 'https://vmc-ptm-api-staging.codingblocks.com/api/';
const baseMeetUrl = 'https://ptm.vidyamandir.com/api/'
// const baseMeetUrl = 'http://localhost:3000/api/'
export async function fetchStudentTeachers(startDate, endDate) {
    const userId = localStorage.getItem('userId');
    const batchCourseData = await securePostAPI({ userId }, "mysa/student/getBatchCourse");
    const { batchId: studentBatchId, courseId: studentCourseId } = batchCourseData || {};
    // let batchId = "89fcf1d1-f77e-41a6-9b8e-1e0b3ea6d6c1"
    // let courseId = "58bc0965-ecce-4969-8391-bc2f308d619f"
    let url = `master/teachers?batchLmsId=${studentBatchId}&courseLmsId=${studentCourseId}`;
    if (startDate) url += `&startDate=${startDate}`;
    if (endDate) url += `&endDate=${endDate}`;

    return axios.get(baseMeetUrl + url)
        .then(res => res.data)
        .catch(err => ({ error: `${err.code} | ${err.message}` }));
}

export async function fetchTeacherAvailability(teacherId, startDate, endDate) {
    return axios.get(baseMeetUrl + `availability/teacher/${teacherId}?startDate=${startDate}&endDate=${endDate}`, {
        headers: getHeaders()
    }).then(res => res.data)
        .catch(err => ({ error: `${err.code} | ${err.message}` }));
}

export async function bookMeeting(slotId, responses, studentName, studentId) {
    const userId = studentId || localStorage.getItem('userId');
    const data = {
        slotId,
        studentId: userId,
        studentName: studentName || '',
        responses
    };
    return axios.post(baseMeetUrl + "meetings/book", data, {
        headers: getHeaders()
    }).then(res => res.data)
        .catch(err => ({ error: `${err.code} | ${err.message}`, serverMessage: err.response?.data?.message || err.response?.data?.error || '' }));
}

export async function fetchMyMeetings(studentId) {
    const userId = studentId || localStorage.getItem('userId');
    return axios.get(baseMeetUrl + `meetings/student?userId=${encodeURIComponent(userId)}`)
        .then(res => res.data)
        .catch(err => ({ error: `${err.code} | ${err.message}` }));
}

export async function fetchMeetingDetails(meetingId) {
    return axios.get(baseMeetUrl + `meetings/${meetingId}`, {
        headers: getHeaders()
    }).then(res => res.data)
        .catch(err => ({ error: `${err.code} | ${err.message}` }));
}

export async function fetchMeetingResponses(meetingId) {
    return axios.get(baseMeetUrl + `meetings/${meetingId}/responses`, {
        headers: getHeaders()
    }).then(res => res.data)
        .catch(err => ({ error: `${err.code} | ${err.message}` }));
}

export async function updateMeetingSubmission(meetingId, responses) {
    return axios.put(baseMeetUrl + `meetings/${meetingId}/submission`, { responses }, {
        headers: getHeaders()
    }).then(res => res.data)
        .catch(err => ({ error: `${err.code} | ${err.message}` }));
}

export async function fetchActiveForm() {
    return axios.get(baseMeetUrl + "admin/active-form", {
        headers: getHeaders()
    }).then(res => res.data)
        .catch(err => ({ error: `${err.code} | ${err.message}` }));
}

export async function fetchMeetingNotes(meetingId) {
    return axios.get(baseMeetUrl + `meetings/${meetingId}/notes`, {
        headers: getHeaders()
    }).then(res => res.data)
        .catch(err => ({ error: `${err.code} | ${err.message}` }));
}

export async function cancelMeeting(meetingId) {
    return axios.delete(baseMeetUrl + `meetings/${meetingId}`, {
        headers: getHeaders()
    }).then(res => res.data)
        .catch(err => ({ error: `${err.code} | ${err.message}` }));
}

export async function fetchPTMNotifications(lmsUserId) {
    return axios.get(baseMeetUrl + `notifications?userId=${lmsUserId}`)
        .then(res => res.data)
        .catch(() => []);
}

export async function markPTMNotificationSeen(notificationId, lmsUserId) {
    return axios.patch(baseMeetUrl + `notifications/${notificationId}/seen?userId=${lmsUserId}`)
        .then(res => res.data)
        .catch(() => null);
}
